// Central configuration for platform footer content and structure.

const CURRENT_YEAR = new Date().getFullYear();

const footerConfig = {
  brand: {
    name: "Orrith",
    tagline: "Cycle of Certainty.",
    ecosystemLabel: "",
  },

  sections: {
    services: {
      heading: "Platform",
      links: [
        { label: "Orrith Landing", path: "/orrith-landing" },
         { label: "Marketplace", path: "/farm" },
         { label: "Forecasting", path: "/farmpulse" },
        { label: "Impact", path: "/farmmark" },
        { label: "NorthStar", path: "/north-star" },
      ],
    },

    support: {
      heading: "Support",
      links: [
        { label: "Support Center", path: "/support" },
        { label: "My Tickets", path: "/support/tickets" },
        { label: "Community Guidelines", path: "/legal/community-guidelines" },
        { label: "Refund Policy", path: "/legal/refund" },
        { label: "Careers", path: "/careers" },
      ],
    },

    account: {
      heading: "Quick Account Links",
      links: [
        { label: "My Dashboard", path: "/me" },
        { label: "My Impact", path: "/farmmark" },
        { label: "Inbox", path: "/inbox" },
        { label: "Settings", path: "/settings" },
      ],
    },
  },

  legal: [
    { label: "Privacy", path: "/legal/privacy" },
    { label: "Terms", path: "/legal/terms" },
    { label: "Security", path: "/legal/security" },
    { label: "Cookies", path: "/legal/cookies" },
     { label: "Data Processing", path: "/legal/dpa" },
    { label: "Accessibility", path: "/accessibility" },
  ],

  social: [
    {
      platform: "X",
      url: "https://x.com/OrrithHQ",
      ariaLabel: "Follow Orrith on X",
    },
    {
      platform: "LinkedIn",
      url: "https://linkedin.com/company/orrith",
      ariaLabel: "Connect with Orrith on LinkedIn",
    },
    {
      platform: "YouTube",
      url: "https://www.youtube.com/@Orrithos",
      ariaLabel: "Watch Orrith on YouTube",
    },
  ],

  languages: [
    { code: "en", label: "English" },
    { code: "rw", label: "Kinyarwanda" },
  ],

  copyright: `\u00A9 ${CURRENT_YEAR} Orrith. All rights reserved.`,
};

export default footerConfig;